import React from "react";
import { Instagram } from "lucide-react";
import { useContent } from "../contexts/ContentContext";
import { resolveAssetUrl } from "../lib/api";

// Tetris-style bento pattern for up to 12 images
const SPANS = [
    "md:col-span-8 md:row-span-2 aspect-[4/3] md:aspect-auto",
    "md:col-span-4 aspect-square",
    "md:col-span-4 aspect-square",
    "md:col-span-4 aspect-square",
    "md:col-span-4 aspect-square",
    "md:col-span-4 aspect-square",
    "md:col-span-6 md:row-span-2 aspect-[4/3] md:aspect-auto",
    "md:col-span-6 aspect-[3/2]",
    "md:col-span-6 aspect-[3/2]",
    "md:col-span-4 aspect-square",
    "md:col-span-4 aspect-square",
    "md:col-span-4 aspect-square",
];

export default function Gallery() {
    const { t, content } = useContent();
    const imgs = (content?.gallery_images || []).slice(0, 12);

    return (
        <section id="gallery" className="relative py-24 md:py-40 px-4 sm:px-6 lg:px-8" data-testid="gallery-section">
            <div className="max-w-7xl mx-auto">
                <div className="max-w-2xl mb-16">
                    <span className="kicker">{t?.gallery?.kicker}</span>
                    <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl text-brand-navy leading-[1.05]" data-testid="gallery-title">
                        {t?.gallery?.title}
                    </h2>
                    <p className="mt-6 text-base md:text-lg text-slate-600">{t?.gallery?.subtitle}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 auto-rows-[minmax(200px,auto)]">
                    {imgs.map((img, idx) => (
                        <div
                            key={idx}
                            className={`relative overflow-hidden rounded-2xl group ${SPANS[idx] || "md:col-span-4 aspect-square"}`}
                            data-testid={`gallery-item-${idx}`}
                        >
                            <img
                                src={resolveAssetUrl(img.url)}
                                alt={img.alt || `Zarautz ${idx + 1}`}
                                loading="lazy"
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                        </div>
                    ))}
                </div>

                {content?.contact_info?.instagram && (
                    <div className="mt-16 text-center">
                        <a
                            href={content.contact_info.instagram}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand-navy text-white hover:bg-brand-terracotta transition-colors duration-300"
                            data-testid="gallery-instagram-link"
                            aria-label="Visit our Instagram @zarautzbcn"
                        >
                            <Instagram size={24} />
                        </a>
                    </div>
                )}
            </div>
        </section>
    );
}
